(function () {
  'use strict';
  if (customElements.get('leha-goal-navigator')) return;
  const contextKeys = ['preview_theme_id', 'preview_key', '_fd', '_sc', 'view', 'country', 'currency'];
  function contextUrl(path, variant) {
    const here = new URL(location.href), url = new URL(path, here);
    if (url.origin !== here.origin) throw Error('destination');
    contextKeys.forEach(key => { if (here.searchParams.has(key) && !url.searchParams.has(key)) url.searchParams.set(key, here.searchParams.get(key)); });
    if (variant) url.searchParams.set('variant', variant);
    return url.href;
  }
  customElements.define('leha-goal-navigator', class extends HTMLElement {
    #events; #dialog; #frame; #port; #request; #sequence = 0; #savedOverflow; #savedHeight; #config; #html; #bootTimer;
    connectedCallback() {
      if (this.#events) return;
      const config = this.querySelector('[data-nav-config]'), template = this.querySelector('[data-nav-frame]');
      if (!config || !template || typeof MessageChannel === 'undefined') return;
      try {
        this.#config = JSON.parse(config.textContent);
        this.#config.all = contextUrl(this.#config.all);
        this.#config.menAvailable = !!this.#config.men;
        this.#config.men = this.#config.men ? contextUrl(this.#config.men) : this.#config.all;
        this.#config.origin = location.origin;
        if (this.#config.resource) this.#config.resource = contextUrl(this.#config.resource);
        if (this.#config.support) {
          const support = new URL(this.#config.support);
          if (support.protocol !== 'https:') this.#config.support = null;
          else {
            support.search = ''; support.hash = '';
            if (support.hostname === 'wa.me') support.searchParams.set('text', 'مرحبًا، أحتاج مساعدة في فهم خيارات منتجات LEHA والفرق بينها.');
            this.#config.support = support.href;
          }
        }
        this.#html = '<!doctype html><html lang="ar" dir="rtl"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><meta name="referrer" content="no-referrer"><meta http-equiv="Content-Security-Policy" content="default-src &apos;none&apos;; script-src https:; style-src https: &apos;unsafe-inline&apos;; font-src https:; img-src https: data:; connect-src &apos;none&apos;; form-action &apos;none&apos;; base-uri &apos;none&apos;">' + template.innerHTML + '</head><body data-leha-nav-frame class="rr-block fs-exclude ph-no-capture" data-hj-suppress data-clarity-mask data-private><main id="navigator" aria-label="موجّه استكشاف LEHA"></main></body></html>';
      } catch { return; }
      this.#events = new AbortController();
      const signal = this.#events.signal;
      this.#dialog = document.createElement('dialog');
      this.#dialog.setAttribute('open', '');
      this.#dialog.setAttribute('role', 'region');
      this.#dialog.setAttribute('aria-label', 'موجّه استكشاف LEHA');
      this.#dialog.hidden = true;
      const close = document.createElement('button');
      close.type = 'button'; close.className = 'leha-nav-close'; close.textContent = 'إغلاق';
      close.addEventListener('click', () => this.#close(), {signal});
      this.#frame = document.createElement('iframe');
      this.#frame.title = 'صف احتياجك أو اختر هدفك';
      this.#frame.referrerPolicy = 'no-referrer';
      this.#frame.setAttribute('sandbox', 'allow-scripts allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation');
      this.#frame.setAttribute('data-private', '');
      this.#frame.setAttribute('data-hj-suppress', '');
      this.#frame.setAttribute('data-clarity-mask', '');
      this.#frame.className = 'rr-block fs-exclude ph-no-capture';
      this.#frame.addEventListener('load', () => this.#boot(), {signal});
      this.#dialog.append(close, this.#frame);
      this.append(this.#dialog);
      this.#dialog.addEventListener('cancel', event => { event.preventDefault(); this.#close(); }, {signal});
      window.addEventListener('pagehide', () => { this.#close(); this.#resetFrame(); }, {signal});
      window.addEventListener('resize', () => this.#height(this.#savedHeight || 450), {signal});
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(this)) this.#dispose(); }, {signal});
      this.#frame.srcdoc = this.#html;
    }
    #boot() {
      this.#port?.close();
      clearTimeout(this.#bootTimer);
      this.#bootTimer = setTimeout(() => {
        this.#dialog.hidden = true;
        this.querySelector('[data-nav-fallback]').hidden = false;
      }, 10000);
      const channel = new MessageChannel();
      this.#port = channel.port1;
      this.#port.onmessage = event => {
        const message = event.data;
        if (!message || typeof message.type !== 'string') return;
        if (message.type === 'ready') {
          clearTimeout(this.#bootTimer);
          this.#dialog.hidden = false;
          this.querySelector('[data-nav-fallback]').hidden = true;
        }
        if (message.type === 'height' && Number.isFinite(message.value)) this.#height(message.value);
        if (message.type === 'open') this.#open();
        if (message.type === 'close') this.#close();
        if (message.type === 'catalog' && Number.isSafeInteger(message.ticket)) this.#catalog(message.ticket);
      };
      this.#frame.contentWindow.postMessage({type:'boot', config:this.#config}, '*', [channel.port2]);
    }
    #height(value) {
      this.#savedHeight = Math.max(320, Math.min(2400, Math.ceil(value)));
      const modal = this.#dialog.hasAttribute('data-modal');
      this.#frame.style.height = (modal ? Math.min(this.#savedHeight, Math.max(240, window.innerHeight - 118)) : this.#savedHeight) + 'px';
    }
    #open() {
      if (this.#dialog.hasAttribute('data-modal')) return;
      this.#savedOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.#dialog.close();
      this.#dialog.setAttribute('role', 'dialog');
      this.#dialog.setAttribute('aria-modal', 'true');
      this.#dialog.setAttribute('data-modal', '');
      this.#dialog.showModal();
      this.#height(this.#savedHeight || 450);
      this.#port?.postMessage({type:'focus'});
    }
    #restore() {
      if (!this.#dialog?.hasAttribute('data-modal')) return;
      document.documentElement.style.overflow = this.#savedOverflow || '';
      this.#dialog.removeAttribute('data-modal');
      this.#dialog.removeAttribute('aria-modal');
      this.#dialog.setAttribute('role', 'region');
    }
    #close() {
      this.#sequence++; this.#request?.abort();
      this.#port?.postMessage({type:'reset'});
      if (this.#dialog.hasAttribute('data-modal')) {
        this.#dialog.close(); this.#restore(); this.#dialog.setAttribute('open', '');
      }
      this.#height(450);
      this.#port?.postMessage({type:'focus-entry'});
    }
    #resetFrame() {
      this.#sequence++; this.#request?.abort(); this.#port?.close();
      if (this.#frame) this.#frame.srcdoc = this.#html;
    }
    async #catalog(ticket) {
      this.#request?.abort();
      const sequence = ++this.#sequence, controller = this.#request = new AbortController();
      const timer = setTimeout(() => controller.abort(), 10000), started = performance.now();
      try {
        const url = new URL(contextUrl(location.pathname));
        url.hash = ''; url.searchParams.set('section_id', 'leha-goal-navigator-data'); url.searchParams.set('_leha_refresh', String(Date.now()));
        const response = await fetch(url.href, {credentials:'same-origin', cache:'no-store', signal:controller.signal});
        if (!response.ok) throw Error('availability');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const catalog = JSON.parse(doc.querySelector('[data-leha-navigator-catalog]').textContent);
        if (catalog.country !== this.#config.country) throw Error('country');
        const whitelist = new Set(['7345960714374','7346916491398','7347530956934','7468282347654']);
        let unverified = false;
        const products = catalog.products.filter(product => {
          if (!whitelist.has(product.id) || !product.available || (this.#config.allowedProducts?.length && !this.#config.allowedProducts.includes(product.id))) return false;
          try {
            window.LehaCommercialPricing.responseLease(product.pricing, product.variant, this.#config.country, response.headers, performance.now() - started);
            return product.pricing.status === 'resolved';
          } catch { unverified = true; return false; }
        }).map(product => ({id:product.id, variant:product.variant, url:contextUrl(product.url,product.variant), image:product.image ? new URL(product.image, location.href).href : null}));
        if (sequence === this.#sequence && !controller.signal.aborted) this.#port?.postMessage({type:'catalog', ticket, status:unverified ? 'partial' : 'verified', products});
      } catch {
        if (sequence === this.#sequence) this.#port?.postMessage({type:'catalog', ticket, status:'unverified', products:[]});
      } finally { clearTimeout(timer); }
    }
    #dispose() {
      this.#sequence++; this.#request?.abort(); this.#restore();
      clearTimeout(this.#bootTimer);
      this.#port?.postMessage({type:'reset'}); this.#port?.close(); this.#events?.abort(); this.#events = null;
      this.#dialog?.remove(); this.#dialog = null; this.#frame = null;
    }
    disconnectedCallback() { this.#dispose(); }
  });
})();
